import { render, staticRenderFns } from "./ResumeUpload.vue?vue&type=template&id=4279d08a&scoped=true&"
import script from "./ResumeUpload.vue?vue&type=script&lang=ts&"
export * from "./ResumeUpload.vue?vue&type=script&lang=ts&"
import style0 from "./ResumeUpload.vue?vue&type=style&index=0&id=4279d08a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4279d08a",
  null
  
)

export default component.exports